/// <reference path="jquery.d.ts" />
import {IUser, ILocalUser} from './interface/IUser';
import CookieController from "../../../js/lib/CookieController";
export default class User {
    user : IUser;
    url =  '/dynamic/user/check_data.php';

    constructor () {
        this.user = {};
    }
    init () {

    }
    public getUserInfo (callback : any, need_refresh : boolean = true) {
        if (need_refresh) {
            this.getUserInfoAjax(callback);
        } else {
            callback(this.user);
        }
    }
    public getNickname() {
        const user = this.user;
        let nickname = '';
        if (user.local) {
            nickname = user.local.social_ep ? user.local.social_name : user.local.mail;
        }
        else if (this.user.global) {
            nickname = user.global.social ? user.global.social_name : user.global.pmail;
        }
        return nickname;
    }
    private getUserInfoAjax (callback) {
        var that = this;
        $.ajax(this.url + '?do=init', {
            'async': false,
            'method': 'POST',
            'dataType': 'json'
        }).done(function (data) {
            that.user = data;
            that.user.local = that.formatUserData(data);
            callback(that.user);
        });
    }
    private formatUserData (user_data) : ILocalUser {
        var user;
        if (user_data && user_data.local) {
            user = user_data.local;
            if (user.mail.indexOf('@vk') !== -1) {
                user.social_ep = 'vk';
            } else if (user.mail.indexOf('@ok') !== -1) {
                user.social_ep = 'ok';
            } else {
                user.social_ep = false;
            }
        }
        return user;
    }

    getSocialEp  () : any {
        if (this.user && this.user.local) {
            return this.user.local.social_ep;
        }
        return false;
    }
}